import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { filter, Observable, Subscription } from 'rxjs';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { AuthService } from './auth.service';
import { GlobalsService } from './globals.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private router: Router,
    private globalsService: GlobalsService
  ) { }

  subscription: Subscription

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise((resolve, reject) => {
      if (this.subscription) this.subscription.unsubscribe()
      this.globalsService.authSubject.pipe(filter(val => val !== undefined)).subscribe((user) => {
        if (user) {
          resolve(true);
        } else {
          console.log('User is not logged in');
          this.router.navigate(['/login']);
          resolve(false);
        }
      });
    });
  }

}
